// extracted by mini-css-extract-plugin
module.exports = {"root":"_ef9e47","large":"_f7fb0d"};